import React ,{useMemo} from 'react';
import { Pannellum } from "pannellum-react";
//本套件須修改，否則行動裝置畫質會很差，
//pannellum-react/es/pannellum/js/libpannellum.js的1250行
//的'precision mediump float;'改為'precision highp float;'
//參考https://github.com/mpetroff/pannellum/commit/59893bcea4629be059ad3e59c3fa5bde438d292b

import uuid from 'react-uuid'

import '../Config/panoConfig.css'

import {
        panoImgsPath1Url,
        panoImgsPath1Url_c,
        hotSpotsPath1Config,
        panoImgsPath2Url,
        panoImgsPath2Url_c,
        hotSpotsPath2Config,
    } from "../Config/panoConfig"

//path shift
//const [ panoImgsUrl, panoImgsUrl_c, hotSpotsConfig ] = [ panoImgsPath1Url, panoImgsPath1Url_c, hotSpotsPath1Config ]
const [ panoImgsUrl, panoImgsUrl_c, hotSpotsConfig ] = [ panoImgsPath2Url, panoImgsPath2Url_c, hotSpotsPath2Config ]

const PanoScene =  (props) => { 
    
    const {
        isMobile,
        pano,
        imgIndex,
        setPanoLoad,
        goToYaw,
        goToPitch,
        setLookAtCard,
        setNowYaw,
        hotSpotsClickHandler,
        setABShift,
    } = props;
    
    const hotSpotsData = hotSpotsConfig.filter((data)=> data.imgIndex === imgIndex)

    const hotSpots = hotSpotsData.map(data =>  <Pannellum.Hotspot
                                key={uuid()}
                                type={data.type}
                                pitch={data.pitch}
                                yaw={data.yaw}
                                cssClass={data.cssClass}
                                tooltip={data.tooltip}
                                handleClickArg={data.handleClickArg}
                                handleClick={(evt, arg) => {hotSpotsClickHandler(arg.type, arg.args, arg.card)}}
                            />)
    

    return(
        <Pannellum
            ref={pano}
            id={uuid()}
            width="100vw"
            height="100vh"
            image={isMobile ? panoImgsUrl_c[imgIndex] : panoImgsUrl[imgIndex]}
            yaw={goToYaw}
            pitch={goToPitch}
            hfov={imgIndex===0?110:100}
            autoLoad = {true}
            showZoomCtrl={false}
            showFullscreenCtrl={false}
            howControls ={true}
            compass={false}
            //hotspotDebug={true} //打開可快速找到yaw pitch 好用!
            onLoad={() => { setPanoLoad(true);
                            setLookAtCard(false);
                            setABShift(c=>!c);
                    }}
            onRender= {() => {  setNowYaw(pano.current.getViewer().getYaw());
                                //console.log('testOnRender')
                                //console.log(pano.current.getViewer().getConfig());
                                //console.log(pano.current.props.image);
                                //console.log(pano.current.props.yaw);
                        }}
        >
            {hotSpots}
        </Pannellum>
    )
}

export default PanoScene;
